"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHttpError = exports.HTTP_ERROR_STATUS_CODES = exports.isHttpSuccess = exports.HTTP_SUCCESS_STATUS_CODES = void 0;
exports.HTTP_SUCCESS_STATUS_CODES = Object.freeze({
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    203: 'Non-Authoritative Information',
    204: 'No Content',
    205: 'Reset Content',
    206: 'Partial Content',
    207: 'Multi-Status',
    208: 'Already Reported',
});
const isHttpSuccess = (statusCode) => {
    switch (statusCode) {
        case 200:
        case 201:
        case 202:
        case 203:
        case 204:
        case 205:
        case 206:
        case 207:
        case 208:
            return true;
        default:
            return false;
    }
};
exports.isHttpSuccess = isHttpSuccess;
exports.HTTP_ERROR_STATUS_CODES = Object.freeze({
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    410: 'Gone',
    411: 'Length Required',
    412: 'Precondition Failed',
    413: 'Content Too Large',
    414: 'URI Too Long',
    415: 'Unsupported Media Type',
    416: 'Range Not Satisfiable',
    417: 'Expectation Failed',
    421: 'Misdirected Request',
    422: 'Unprocessable Content',
    423: 'Locked',
    424: 'Failed Dependency',
    425: 'Too Early',
    426: 'Upgrade Required',
    428: 'Precondition Required',
    429: 'Too Many Requests',
    431: 'Request Header Fields Too Large',
    451: 'Unavailable For Legal Reasons',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    508: 'Loop Detected',
    511: 'Network Authentication Required',
});
const isHttpError = (statusCode) => {
    switch (statusCode) {
        case 400:
        case 401:
        case 402:
        case 403:
        case 404:
        case 405:
        case 406:
        case 407:
        case 408:
        case 409:
        case 410:
        case 411:
        case 412:
        case 413:
        case 414:
        case 415:
        case 416:
        case 417:
        case 421:
        case 422:
        case 423:
        case 424:
        case 425:
        case 426:
        case 428:
        case 429:
        case 431:
        case 451:
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
        case 505:
        case 506:
        case 507:
        case 508:
        case 511:
            return true;
        default:
            return false;
    }
};
exports.isHttpError = isHttpError;
//# sourceMappingURL=http.js.map